import Section from '../Section';
import BannerSectionStyle2 from '../Section/BannerSection/BannerSectionStyle2';
import ProfileCard from '../Profile/ProfileCard';

const AdminProfile = () => (<>
    <BannerSectionStyle2
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Profile"
        subTitle="User information"
    />
    <Section
        topMd={170}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
    >
        <ProfileCard showGender={false} />
    </Section>
</>);

export default AdminProfile;
